<template>
  <div class="mark-card__assignment">
    <div 
      v-for="item in data" :key="item.id" 
      class="mark-card__assignment-item"
    >
      <button
        type="button"
        :class="[
          'mark-card__assignment-item-btn',
          item.class,
          getGrayClass(item.title)
        ]"
        @mouseenter="hover = true"
        @mouseleave="hover = false"
        @click="toggleSubordinateRight(item)"
      >
        <span class="icon-container">
          <v-icon>{{ item.icon }}</v-icon>
        </span>
        <span class="label">
          {{ item.description }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";

import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: 'AssignmentRights',

  props: {
    idElement: {
      type: Number,
      default: null
    },

    userID: {
      type: Number,
      default: null
    },

    targetRights: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      data: [
        
        {id: 1, title: 'canView', right: 'VIEW', class: 'violetBtn', description: 'просмотр компетенции', icon: 'mdi-eye-outline'},
        {id: 2, title: 'canViewScore', right: 'VIEW_SCORE', class: 'blueBtn', description: 'просмотр оценки', icon: 'mdi-star-outline'},
        {id: 3, title: 'canPostScore', right: 'POST_SCORE', class: 'greenBtn', description: 'оценка компетенции', icon: 'mdi-star-plus-outline'},
        {id: 4, title: 'canPostAnswer', right: 'POST_ANSWER', class: 'yellowBtn', description: 'ответ на задание', icon: 'mdi-chat-outline'},
        {id: 5, title: 'assigned', right: 'ASSIGN_ELEMENT', class: 'redBtn', description: 'назначить компетенцию', icon: 'mdi-pin-outline'},
        {id: 6, title: 'canViewReferenceAnswer', right: 'VIEW_REFERENCE_ANSWER', class: 'orangeBtn', description: 'просмотр эталонного ответа', icon: 'mdi-key-outline'},
      ],
      hover: false,
      localSubordinateRights: {},
    }
  },

  watch: {
    hover(newVal) {
      this.$emit('changeHoverCard', newVal)
    },

    targetRights: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localSubordinateRights = value || {};
      }
    }
  },

  methods: {
    getGrayClass(key) {
      // если прав нет или ключа нет / false — красим в серый
      if (
        !this.localSubordinateRights ||
        !Object.prototype.hasOwnProperty.call(this.localSubordinateRights, key) ||
        !this.localSubordinateRights[key]
      ) {
        return "gray";
      }
      return "";
    },
    
    async toggleSubordinateRight(item) {
      const key = item.title;
      const right = item.right;
      const hasRight = this.localSubordinateRights[key] === true;

      const action = hasRight ? "revoke" : "assign";

      const body = {
        elementId: this.idElement,
        subordinateId: this.userID,
        right: right,
        action: action,
        returnType: "single" 
      };

      const res = await GlobalRequest.request(`/assigment/manage-right`, "POST", body);
      // console.log(res)
      // Если вернулась ошибка
      if(res && res.serviceAnswer && res.serviceAnswer.error) {
        await this.notifyVue('bottom', 'right', "Не удалось изменить назначение права");
      } else {
        this.$set(this.localSubordinateRights, key, !hasRight);
      }

      this.$emit("saveManageAssigment", res);
    },

    async notifyVue(verticalAlign, horizontalAlign, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "danger",
        message: text,
      });
    },
    
  }
}
</script>

<style>
  .markCard {
    position: relative;
  }
  /* .mark-card .v-list-item__content,
  .mark-card .text-h6 {
    overflow: visible !important;
  } */

  .mark-card__container {
    display: flex;
    justify-content: space-between;
  }
  .mark-card__assignment {
    position: absolute;
    left: -19px;
    top: 0;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .mark-card__assignment-item {
    position: relative;
    margin-bottom: 5px;
  }
  .mark-card__assignment-item:last-child {
    margin-bottom: 0;
  }


  button.blueBtn,
  button.blueBtn .icon-container{
    background-color: #7CE4FE;
    color: #3091B2;
  }
  button.greenBtn,
  button.greenBtn .icon-container {
    background-color: #8EF3C5;
    color: #229863;
  }
  button.yellowBtn,
  button.yellowBtn .icon-container {
    background-color: #FFE28C;
    color: #BB992F;
  }
  button.redBtn,
  button.redBtn .icon-container {
    background-color: #FF8F5E;
    color: #B33C12;
  }
  button.violetBtn,
  button.violetBtn .icon-container {
    background-color: #be7cfe;
    color: #5d30b2;
  }
  button.orangeBtn,
  button.orangeBtn .icon-container {
    background-color: #ffb066;
    color: #a85c00;
  }

  button i.v-icon{
    transition: 0.3s;
  }

  button.blueBtn i.v-icon{
    color: #48cff1;
  }
  button.blueBtn:hover i.v-icon{
    color: #3091B2;
  }

  button.greenBtn i.v-icon {
    color: #50db9c;
  }
  button.greenBtn:hover i.v-icon {
    color: #229863;
  }

  button.yellowBtn i.v-icon {
    color: #edc755;
  }
  button.yellowBtn:hover i.v-icon {
    color: #BB992F;
  }

  button.redBtn i.v-icon {
    color: #db835c;
    transform: rotate(45deg);
  }
  button.redBtn:hover i.v-icon {
    color: #B33C12;
  }

  button.violetBtn i.v-icon {
    color: #a950ff;
  }
  button.violetBtn:hover i.v-icon {
    color: #5d30b2;
  }

  button.orangeBtn i.v-icon {
    color: #ffb066;
  }
  button.orangeBtn:hover i.v-icon {
    color: #a85c00;
  }


  .mark-card__assignment-item-btn {
    height: 19px;
    width: 200px;
    padding: 0 10px 0 23px;
    outline: 0;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    transition: 0.3s ease;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    opacity: 0.3s;
  }
  .mark-card__assignment-item-btn:hover {
    transform: translate(-6px, 0);
    z-index: 9;
  }

  .mark-card__assignment-item-btn.gray {
    filter: grayscale();
  }

  .mark-card__assignment-item-btn .label {
    opacity: 0;
    margin-left: 6px;
    transition: opacity 0.1s ease;
    font-size: 10px;
    letter-spacing: .0892857143em;
    text-transform: uppercase;
    user-select: none;
  }
  .mark-card__assignment-item-btn .icon-container {
    align-items: center;
    display: inline-flex;
    position: absolute;
    left: 0px;
    top: 0;
    padding-left: 1px;
    padding-top: 1px;
    width: 18px;
    z-index: 1;
  }
  .mark-card__assignment-item-btn .icon-container i.v-icon {
    font-size: 16px;
    line-height: 1;
  }

  

  .mark-card__assignment-item-btn:hover .label {
    opacity: 1;
  }

.markCard .v-list-item__content,
.markCard .v-card__actions {
  transition: 0.3s;
}

.markCard.is-hovered .v-list-item__content,
.markCard.is-hovered .v-card__actions {
  opacity: 0.2;
}

</style>
